import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectActiveCampaignRequiresApproval } from '@/store/selectors/campaignManagement.selectors';
import { approveActiveCampaign } from '@/store/slices/campaignManagementSlice';
import { CheckCircleOutline } from '@mui/icons-material';
import { Collapse } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const RequireApprovalBanner = () => {
  const dispatch = useAppDispatch();
  const campaignRequiresApproval = useAppSelector(selectActiveCampaignRequiresApproval);

  const [showBanner, setShowBanner] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (campaignRequiresApproval) {
      setShowBanner(true);
    }
  }, [campaignRequiresApproval]);

  useEffect(() => () => setShowBanner(false), []);

  const handleApprove = useCallback(async () => {
    try {
      setLoading(true);
      await dispatch(approveActiveCampaign()).unwrap();
      setShowBanner(false);
      toast.success('Campaign approved and activated successfully');
    } catch {
      toast.error('Failed to approve campaign');
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  return (
    <Collapse in={showBanner}>
      <div className='flex items-center justify-center py-4 bg-[#1B4332] gap-4'>
        <p className='text-[#fff]'>This campaign needs your approval. After approving it will be activated.</p>
        <button
          className='flex items-center justify-center gap-1 py-1 px-4 rounded-full bg-[#fff] text-[#1B4332] text-[14px] font-semibold hover:scale-[1.03]'
          onClick={handleApprove}
          disabled={loading}
        >
          Approve and activate <CheckCircleOutline sx={{ fill: '#1B4332', width: '18px' }} />
        </button>
      </div>
    </Collapse>
  );
};

export default RequireApprovalBanner;
